import { genInternalId } from "./id-parser";
export const correlationIdHeader = "x-crm-correlation-id";
export const genCorrelationId = (source) => {
    return `${source}-${genInternalId()}`;
};
//# sourceMappingURL=correlation-id.js.map